const WEBSITE = 'https://ennoventure.com/'
const YOUTUBE = [
  'https://www.youtube.com/embed/UHpD5UBU8VQ',
  'https://www.youtube.com/embed/j6bDSxVGdUU',
]
const CONTACT = 'https://ennoventure.com/contact/'
const TWITTER = 'https://twitter.com/ennoventure/'
const FB = 'https://www.facebook.com/ennoventure/'
const INSTAGRAM = 'https://www.instagram.com/ennoventure/'
const LINKEDIN = 'https://www.linkedin.com/company/ennoventure/'

export default {
  WEBSITE,
  YOUTUBE,
  CONTACT,
  TWITTER,
  FB,
  INSTAGRAM,
  LINKEDIN,
}
